<template>
  <div class="container">
    <div class="configList">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" tab-position="left">
        <el-tab-pane  :label="item.name" :name="item.name" v-for="(item,index) in configList" :key="index">
          <el-form  :model="formInline" class="demo-form-inline">
            <el-form-item  :label="'条件'+(indexs+1)" v-for="(items,indexs) in item.condition" :key="indexs">
              <el-input style="width:200px" v-model="items.key" placeholder="请输入条件字段" clearable />-
              <el-input style="width:200px" v-model="items.condition" placeholder="请输入判断条件" clearable />-
              <el-input style="width:200px" v-model="items.value" placeholder="请输入字段值" clearable />
              <el-icon @click="addCondition(index)" v-if="indexs==item.condition.length-1" style="margin-left: 20px"><Plus /></el-icon>
              <el-icon @click="delCondition(index,indexs)" v-if="indexs<item.condition.length" style="margin-left: 20px"><Minus /></el-icon>
            </el-form-item>
            <el-form-item >
              <el-button style="margin: 0 auto" type="primary" @click="onSubmit(index)">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>
<script>
import {ElForm, ElFormItem, ElButton, ElInput, ElTabs, ElTabPane, ElIcon, ElMessage} from "element-plus";
import {bestbuyConfig,addbestbuyConfig} from "@/utils/api"
export default {
  name: "stampConfig",
  components:{ElForm, ElFormItem, ElButton, ElInput,ElTabs,ElTabPane,ElIcon},
  data(){
    return{
      activeName:'BBY卡派发货',
      configList:[
          {name:"BBY卡派发货",condition:[
              {key:"",condition:"=",value:""},

            ]
          },
          {name:"Shopify卡派发货",condition:[
              {key:"",condition:"=",value:""}
            ]
          },
      ]
    }
  },
  beforeMount() {
    this.bestbuyConfig()
  },
  methods:{
    bestbuyConfig(){
      bestbuyConfig().then(res => {
        this.configList = res.Data.data
      }).catch(err=>{
        console.log(err)
      })
    },
    handleClick(tab,event){
      this.activeName =  tab.props.name
      console.log(event)
    },
    addCondition(index){
      this.configList[index].condition.push({key:"",condition:"=",value:""})
    },
    delCondition(index,indexs){
      this.configList[index].condition.splice(indexs,1);
    },
    onSubmit(index){
      addbestbuyConfig(this.configList[index]).then(res=>{
        console.log(res)
        ElMessage.success("保存成功")
      }).catch(err=>{
        console.log(err)
      })
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
.configList{
  margin: 50px 5%;
}
.demo-tabs {
  min-height: 500px;
}
</style>